export class OrderData {
    public id:number|null;
    public shipment_id:string;

    constructor(data:OrderDataData|void) {
        if(data === undefined)
        {
            this.id = null;
            this.shipment_id = "";
        }
        else
        {
            this.id = data.id;
            this.shipment_id = data.shipment_id;
        }
    }
}

export type OrderDataData = {
    id:number|null;
    shipment_id:string;
}